import {
    useEffect,
    useState } from 'react';
import {
  printDebugLog
} from '../../../constants/constant';

export function useDeviceType(getDeviceType=()=>{}) {
    const [deviceInfo, setDeviceInfo] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: false,
        isTV: false,
        deviceType: 'Unknown',
        screenWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    });

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const mediaQuery = window.matchMedia('(max-width: 767px)');

        const detectDevice = (isMatch) => {
            const width = window.innerWidth;
            const deviceType = getDeviceType(userAgent);

            const isMobile = deviceType === 'Mobile' || (isMatch && width <= 767);
            const isTablet = deviceType === 'Tablet';
            const isTV = deviceType === 'TV';
            const isDesktop = !isMobile && !isTablet && !isTV;

            printDebugLog('Device Info:', {
                deviceType,
                isMobile,
                isTablet,
                isTV,
                isDesktop,
                screenWidth: width,
            });

            setDeviceInfo({
                isMobile,
                isTablet,
                isDesktop,
                isTV,
                deviceType,
                screenWidth: width,
            });
        };

        const handleChange = (event) => {
            detectDevice(event.matches);
        };

        detectDevice(mediaQuery.matches);

        mediaQuery.addEventListener('change', handleChange);
        window.addEventListener('popstate', handleChange);
        window.addEventListener('hashchange', handleChange);
        window.addEventListener('resize', handleChange); // Optional, for screen width changes

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
            window.removeEventListener('popstate', handleChange);
            window.removeEventListener('hashchange', handleChange);
            window.removeEventListener('resize', handleChange);
        };
    }, [getDeviceType]);

    return deviceInfo;
}
